import { Toaster as Sonner, toast } from "sonner"
import { CheckCircle } from "lucide-react"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      icons={{
        success: <div style={{ 
          width: '20px', 
          height: '20px', 
          borderRadius: '50%', 
          backgroundColor: '#C9D7E9', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center' 
        }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#0F2444" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>,
      }}
      toastOptions={{
        style: {
          background: '#F3EEE4',
          color: '#51120A',
          border: '1px solid #D6D0C2',
          fontFamily: "'Bricolage Grotesque', sans-serif",
        },
        classNames: {
          toast: "group toast",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
